import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    Grid,
    MenuItem,
    Select,
    Typography,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Modal,
    IconButton,
    TablePagination,
    Chip,
    TextField,
} from '@mui/material';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import DevicesIcon from '@mui/icons-material/Devices';
// import TuneIcon from '@mui/icons-material/Tune';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';
// import TableChartIcon from '@mui/icons-material/TableChart';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// ─── Mock Data ────────────────────────────────────────────────────────────────

const summaryCards = [
    { label: 'Total Recon Records', value: 21, color: '#1976d2', icon: '📋' },
    { label: 'Matched Records', value: 14, color: '#2e7d32', icon: '✅' },
    { label: 'Under Review', value: 4, color: '#ed6c02', icon: '🔔' },
    { label: 'Unmatched Records', value: 3, color: '#d32f2f', icon: '❌' },
];

const reconciliationRows = [
    { 
        id: 1, 
        reconDate: '2 Apr 2024', 
        surfixNo: '1201', 
        channel: 'Mobile Banking', 
        systemTxnCount: '125', 
        gatewayTxnCount: '125', 
        bankAmount: '25000', 
        varianceAmount: 'Matched', 
        status: 'Matched' 
    },
    { 
        id: 2, 
        reconDate: '3 Apr 2024', 
        surfixNo: '1202', 
        channel: 'Online Transfer', 
        systemTxnCount: '98', 
        gatewayTxnCount: '100', 
        bankAmount: '18500', 
        varianceAmount: 'Under Review', 
        status: 'UnderReview' 
    },
    { 
        id: 3, 
        reconDate: '4 Apr 2024', 
        surfixNo: '1203', 
        channel: 'ATM Deposit', 
        systemTxnCount: '76', 
        gatewayTxnCount: '74', 
        bankAmount: '14200', 
        varianceAmount: 'Unmatched', 
        status: 'Unmatched' 
    },
    { 
        id: 4, 
        reconDate: '5 Apr 2024', 
        surfixNo: '1204', 
        channel: 'Card Payment', 
        systemTxnCount: '210', 
        gatewayTxnCount: '210', 
        bankAmount: '50200', 
        varianceAmount: 'Matched', 
        status: 'Matched' 
    },
    { 
        id: 5, 
        reconDate: '6 Apr 2024', 
        surfixNo: '1205', 
        channel: 'QR Payment', 
        systemTxnCount: '54', 
        gatewayTxnCount: '58', 
        bankAmount: '9700', 
        varianceAmount: 'Under Review', 
        status: 'UnderReview' 
    },
];

const varianceDetailSummary = [
    { status: 'CONFIRMED', count: 45, amount: '250,000', age: '5 days', color: '#ed6c02' },
    { status: 'PENDING', count: 20, amount: '120,000', age: '3 days', color: '#1976d2' },
    { status: 'SUSPEND', count: 12, amount: '80,000', age: '2 days', color: '#5c35a0' },
    { status: 'COMPLETED', count: 500, amount: '2,100,000', age: '0 days', color: '#2e7d32' },
    { status: 'FAILED', count: 6, amount: '40,000', age: '7 days', color: '#d32f2f' },
];

const varianceRows = [
    { id: 1, ref: 'RFD-152214', channel: 'Memo', internalRef: 'NIWr-20234', gatewayRef: 'RFD-99234', bankRef: 'RFD-10239', expected: 'RFD-5550.00', actual: 'RND 8,500.00', difference: 'Under Review', reasonCode: '', assignedTo: 'Admin' },
    { id: 2, ref: 'RFD-152215', channel: 'Memo', internalRef: 'NIWr-18358', gatewayRef: 'RFD-95385', bankRef: 'RFD-85569', expected: 'RFD-6550.00', actual: 'RND 8,300.00', difference: 'Unmatched', reasonCode: '', assignedTo: 'Admin' },
    { id: 3, ref: 'RFD-152216', channel: 'Mobile', internalRef: 'NIWr-18358', gatewayRef: 'RFD-95698', bankRef: 'RFD-95698', expected: 'RFD-6550.00', actual: 'RND 3,300.00', difference: 'Unmatched', reasonCode: '', assignedTo: 'Admin' },
];

// ─── Status chip helper ───────────────────────────────────────────────────────

const StatusChip = ({ status }) => {
    const map = {
        Matched: { bg: '#2e7d32', label: 'Matched' },
        UnderReview: { bg: '#ed6c02', label: 'Under Review' },
        Unmatched: { bg: '#d32f2f', label: 'Unmatched' },
        'Under Review': { bg: '#ed6c02', label: 'Under Review' },
    };
    const cfg = map[status] || { bg: '#999', label: status };
    return (
        <Chip label={cfg.label} size="small"
            sx={{ backgroundColor: cfg.bg, color: '#fff', fontWeight: 600, fontSize: 11, minWidth: 90 }} />
    );
};

// ─── Pagination hook ──────────────────────────────────────────────────────────

const usePagination = (defaultRows = 10) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(defaultRows);
    return {
        page, rowsPerPage,
        handleChangePage: (_, p) => setPage(p),
        handleChangeRowsPerPage: (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); },
        startIndex: page * rowsPerPage,
    };
};

// ─── Component ────────────────────────────────────────────────────────────────

const DailyChannelReconciliationPage = () => {

    // Filters
    const [dateRange, setDateRange] = useState('');
    const [channel, setChannel] = useState('');
    const [reconStatus, setReconStatus] = useState('');

    // Detail modal
    const [detailOpen, setDetailOpen] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const handleDetailOpen = (row) => { setCurrentRow(row); setDetailOpen(true); };
    const handleDetailClose = () => { setCurrentRow(null); setDetailOpen(false); };

    // Paginations
    const reconPag = usePagination();
    const variancePag = usePagination();

    const varianceDetailSummaryPag = usePagination();

    // Shared cell styles — same as sample code
    const thSx = { py: 1 };
    const tdSx = { py: 0 };

    return (
        <Container component="main" maxWidth="full" sx={{ py: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                {/* ── Page Title ── */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 3, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: 0.5 }}>
                        Daily Channel Reconciliation
                    </Typography>
                </Box>
{/* ── Summary Cards ── */}
<Box
  sx={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: 2,
    width: '100%',
    mb: 3
  }}
>
  {summaryCards.map((card) => (
    <Paper
      key={card.label}
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        height: '100%'
      }}
    >
      <Typography sx={{ fontSize: 28 }}>{card.icon}</Typography>
      <Box>
        <Typography variant="body2" color="text.secondary">
          {card.label}
        </Typography>
        <Typography
          variant="h5"
          sx={{ fontWeight: 700, color: card.color }}
        >
          {card.value}
        </Typography>
      </Box>
    </Paper>
  ))}
</Box>
                {/* ── Filter Bar ── */}
               <Box
  sx={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: 1.5,
    width: '100%',
    mb: 1,
    alignItems: 'center'
  }}
>
  <FormControl size="small" fullWidth>
    <InputLabel>Date Range</InputLabel>
    <Select value={dateRange} onChange={e => setDateRange(e.target.value)} label="Date Range">
      <MenuItem value="today">Today</MenuItem>
      <MenuItem value="this_week">This Week</MenuItem>
      <MenuItem value="1apr_15apr">1 Apr 2024 – 15 Apr 2024</MenuItem>
      <MenuItem value="this_month">This Month</MenuItem>
    </Select>
  </FormControl>

  <FormControl size="small" fullWidth>
    <InputLabel>Channel</InputLabel>
    <Select value={channel} onChange={e => setChannel(e.target.value)} label="Channel">
      <MenuItem value="travel_card_online">Travel Card Online</MenuItem>
      <MenuItem value="online_booking">Online Booking</MenuItem>
      <MenuItem value="online_onboard">Online Onboard</MenuItem>
      <MenuItem value="govt_pass">Govt Pass</MenuItem>
    </Select>
  </FormControl>

  <FormControl size="small" fullWidth>
    <InputLabel>Recon Status</InputLabel>
    <Select value={reconStatus} onChange={e => setReconStatus(e.target.value)} label="Recon Status">
      <MenuItem value="matched">Matched</MenuItem>
      <MenuItem value="under_review">Under Review</MenuItem>
      <MenuItem value="unmatched">Unmatched</MenuItem>
    </Select>
  </FormControl>
</Box>

                {/* ── Action buttons row ── */}
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 3, alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
                    <Button
                        variant="contained"
                        sx={{ padding: '6px 24px', fontWeight: 'bold', borderRadius: '4px', height: '40px', backgroundColor: '#3f51b5', color: '#fff', '&:hover': { backgroundColor: '#303f9f' } }}
                    >
                        Apply Filters
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<RefreshIcon />}
                        sx={{ fontWeight: 'bold', borderRadius: '4px', height: '40px', textTransform: 'none' }}
                    >
                        Reset
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<DownloadIcon />}
                        endIcon={<KeyboardArrowDownIcon />}
                        sx={{ fontWeight: 'bold', borderRadius: '4px', height: '40px', textTransform: 'none' }}
                    >
                        Export
                    </Button>
                    <IconButton size="small"><MoreHorizIcon /></IconButton>
                </Box>

                {/* ══════════════════════════════════════════
                    TABLE 1 — Channel Reconciliation Summary
                    + Variance Detail side panel (right col)
                ══════════════════════════════════════════ */}
                <Grid container sx={{ width: '100%' }}>

                    {/* Main reconciliation table */}
                    <Grid item xs={12} sx={{ mb: 4 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2,}}>
                            {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>Channel Reconciliation Summary</Typography>
                        </Box>
                        <Paper variant="outlined" sx={{ borderRadius: 2 }}>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                            <TableCell sx={thSx}>#</TableCell>
                                            <TableCell sx={thSx}>Recon Date</TableCell>
                                            <TableCell sx={thSx}>Surfix No</TableCell>
                                            <TableCell sx={thSx}>Channel</TableCell>
                                            <TableCell sx={thSx}>System Txn Count</TableCell>
                                            <TableCell sx={thSx}>Gateway Txn Count</TableCell>
                                            <TableCell sx={thSx}>Bank Amount</TableCell>
                                            <TableCell sx={thSx}>Variance Amount</TableCell>
                                            <TableCell sx={thSx}>Status</TableCell>
                                            <TableCell sx={thSx}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {reconciliationRows
                                            .slice(reconPag.startIndex, reconPag.startIndex + reconPag.rowsPerPage)
                                            .map((row) => (
                                                <TableRow key={row.id}>
                                                    <TableCell sx={tdSx}>{row.id}</TableCell>
                                                    <TableCell sx={tdSx}>{row.reconDate}</TableCell>
                                                    <TableCell sx={tdSx}>{row.surfixNo}</TableCell>
                                                    <TableCell sx={tdSx}>{row.channel}</TableCell>
                                                    <TableCell sx={tdSx}>{row.systemTxnCount}</TableCell>
                                                    <TableCell sx={tdSx}>{row.gatewayTxnCount}</TableCell>
                                                    <TableCell sx={tdSx}>{row.bankAmount}</TableCell>
                                                    <TableCell sx={tdSx}>250</TableCell>
                                                    <TableCell sx={tdSx}>
                                                        <StatusChip status={row.status} />
                                                    </TableCell>
                                                    <TableCell sx={tdSx}>
                                                        <Button size="small" endIcon={<KeyboardArrowDownIcon />}
                                                            sx={{ minWidth: 0, p: '2px 6px', borderRadius: '4px', border: '1px solid #ccc', color: '#555', textTransform: 'none' }}>
                                                            •••
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                showFirstButton showLastButton
                                component="div"
                                count={reconciliationRows.length}
                                page={reconPag.page}
                                onPageChange={reconPag.handleChangePage}
                                rowsPerPage={reconPag.rowsPerPage}
                                onRowsPerPageChange={reconPag.handleChangeRowsPerPage}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                            />
                        </Paper>
                    </Grid>


                </Grid>

                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 1, flexWrap: 'wrap', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>Variance Detail</Typography>
                    </Box>
                    {/* <IconButton size="small"><MoreHorizIcon /></IconButton> */}
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%', mb: 4 }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>Status</TableCell>
                                <TableCell sx={thSx}>Count</TableCell>
                                <TableCell sx={thSx}>Amount</TableCell>
                                <TableCell sx={thSx}>Oldest Age</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {varianceDetailSummary.map((row) => (
                                <TableRow key={row.status}>
                                    <TableCell sx={tdSx}>
                                        <Chip label={row.status} size="small"
                                            sx={{ backgroundColor: row.color, color: '#fff', fontWeight: 700, fontSize: 10, width: 100 }} />
                                    </TableCell>
                                    <TableCell sx={tdSx}>{row.count}</TableCell>
                                    <TableCell sx={tdSx}>{row.amount}</TableCell>
                                    <TableCell sx={tdSx}>{row.age}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={varianceDetailSummary.length}
                        page={varianceDetailSummaryPag.page}
                        onPageChange={varianceDetailSummaryPag.handleChangePage}
                        rowsPerPage={varianceDetailSummaryPag.rowsPerPage}
                        onRowsPerPageChange={varianceDetailSummaryPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>


                {/* ══════════════════════════════════════════
                    TABLE 2 — Variance Detail
                ══════════════════════════════════════════ */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 1, flexWrap: 'wrap', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>Variance Detail</Typography>
                    </Box>
                    <IconButton size="small"><MoreHorizIcon /></IconButton>
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>#</TableCell>
                                <TableCell sx={thSx}>Variance Ref No.</TableCell>
                                <TableCell sx={thSx}>Channel</TableCell>
                                <TableCell sx={thSx}>Internal Ref No.</TableCell>
                                <TableCell sx={thSx}>Gateway Ref No.</TableCell>
                                <TableCell sx={thSx}>Bank Ref No.</TableCell>
                                <TableCell sx={thSx}>Bank Amount</TableCell>
                                <TableCell sx={thSx}>System Amount</TableCell>
                                <TableCell sx={thSx}>Difference</TableCell>
                                <TableCell sx={thSx}>Reason Code</TableCell>
                                <TableCell sx={thSx}>Assigned To</TableCell>
                                <TableCell sx={thSx}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {varianceRows
                                .slice(variancePag.startIndex, variancePag.startIndex + variancePag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell sx={tdSx}>{row.id}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <Typography
                                                variant="body2"
                                                sx={{ color: '#1976d2', cursor: 'pointer', fontWeight: 600, '&:hover': { textDecoration: 'underline' } }}
                                                onClick={() => handleDetailOpen(row)}
                                            >
                                                {row.ref}
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.channel}</TableCell>
                                        <TableCell sx={tdSx}>{row.internalRef}</TableCell>
                                        <TableCell sx={tdSx}>{row.gatewayRef}</TableCell>
                                        <TableCell sx={tdSx}>{row.bankRef}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 700 }}>{row.expected}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 700 }}>{row.actual}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <StatusChip status={row.difference} />
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.reasonCode || '—'}</TableCell>
                                        <TableCell sx={tdSx}>{row.assignedTo}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <Button size="small" endIcon={<KeyboardArrowDownIcon />}
                                                sx={{ minWidth: 0, p: '2px 6px', borderRadius: '4px', border: '1px solid #ccc', color: '#555', textTransform: 'none' }}>
                                                •••
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={varianceRows.length}
                        page={variancePag.page}
                        onPageChange={variancePag.handleChangePage}
                        rowsPerPage={variancePag.rowsPerPage}
                        onRowsPerPageChange={variancePag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

                {/* ══════════════════════════════════════════
                    Variance Detail Modal — same style as sample
                ══════════════════════════════════════════ */}
                <Modal open={detailOpen} onClose={handleDetailClose}>
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        maxWidth: 520,
                        bgcolor: 'background.paper',
                        border: '2px solid gray',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '10px',
                    }}>
                        <Typography variant="h6" gutterBottom>Variance Detail — {currentRow?.ref}</Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Channel" value={currentRow?.channel || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Internal Ref No." value={currentRow?.internalRef || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Gateway Ref No." value={currentRow?.gatewayRef || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Bank Ref No." value={currentRow?.bankRef || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Expected Amount" value={currentRow?.expected || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Actual Amount" value={currentRow?.actual || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth multiline rows={3} size="small" label="Resolution Note" placeholder="Enter note..." />
                            </Grid>
                        </Grid>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Button variant="contained" color="primary" onClick={handleDetailClose} sx={{ marginRight: '8px' }}>
                                Save
                            </Button>
                            <Button variant="contained" onClick={handleDetailClose} sx={{ backgroundColor: 'gray' }}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Modal>

            </Box>
        </Container>
    );
};

export default DailyChannelReconciliationPage;